export const ROLE_CONTRIBUTOR = 'contr'
export const ROLE_CONSUMER = 'consm'
